import {useEffect} from 'react';
import Header from './Header';
import Seo from '../Seo';

// Shell shared by the new-style pages: header with socials, centred copyright.
// seo — props for <Seo/> (title, description, path, ...)
const Layout = ({lang, seo, className = '', style, children}) => {
  // The old layout offsets <body> for the sidebar; new pages have none
  useEffect(() => {
    document.body.classList.add('home-body');
    return () => document.body.classList.remove('home-body');
  }, []);

  return (
    <div className={`home ${className}`} style={style}>
      <Seo lang={lang} {...seo}/>

      <Header lang={lang}/>

      <main className="home-main">
        {children}
      </main>

      <footer className="home-footer">
        <span className="home-footer__copy">© 2026 Nikita Chernykh</span>
      </footer>
    </div>
  );
};

export default Layout;
